import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { PROFILE } from "@/data";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function BeyondScreen() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [50, -50]);

  return (
    <section id="beyond" ref={ref} data-testid="beyond-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute bottom-0 left-1/4 w-[26rem] h-[26rem] rounded-full bg-[#2C4A73]/40 blur-[130px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <SectionHeading id="beyond" overline="How I Work" title="Built with intent." />
          <Reveal delay={0.1}>
            <p className="font-editorial italic text-xl sm:text-2xl text-[#EDEAE0] leading-relaxed max-w-2xl" data-testid="beyond-quote">
              "I believe the best digital work happens when strategy and execution stay connected."
            </p>
            <p className="mt-6 text-base sm:text-lg text-[#9DAEC4] leading-relaxed max-w-2xl">
              I don't separate ideas from implementation. I research, build, test, measure, and improve —
              staying involved from the first decision to the final result.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap gap-3">
              {["Think", "Build", "Optimize"].map((t) => (
                <span
                  key={t}
                  data-testid={`beyond-chip-${t.toLowerCase()}`}
                  className="text-xs font-mono uppercase tracking-widest text-[#D9A441] border border-[#D9A441]/30 rounded-full px-4 py-2 bg-[#D9A441]/5"
                >
                  {t}
                </span>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2 relative">
          <Reveal>
            <div className="relative" data-testid="beyond-frame">
              <div className="absolute -top-3 -right-3 w-10 h-10 border-t-2 border-r-2 border-[#D9A441] z-10" />
              <div className="absolute -bottom-3 -left-3 w-10 h-10 border-b-2 border-l-2 border-emerald-400 z-10" />
              <div className="overflow-hidden rounded-xl border border-white/10 shadow-xl shadow-black/40">
                <motion.img
                  style={{ y, objectPosition: "center 30%" }}
                  src={PROFILE.workspace}
                  alt={`${PROFILE.name} at his workspace`}
                  data-testid="beyond-image"
                  className="w-full aspect-[4/5] object-cover scale-110"
                />
              </div>
              <div className="absolute top-5 right-5">
                <span className="text-xs font-mono bg-[#0A1730]/85 backdrop-blur border border-white/10 rounded-full px-3 py-1.5 text-[#D9A441]">
                  WORKSPACE · BOGURA
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
